import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  templateUrl: './app.header.component.html',
})
export class AppHeaderComponent {
  constructor(public auth: AuthService, private translate: TranslateService) {}
  currentLang = 'en';
  useLanguage(language: string) {
    this.translate.use(language);
    this.currentLang = language;
  }
}
